import { Component } from "react";
import {Link} from "react-router-dom";
import {JJ_IMedical_icon} from "../../assets";

class HeaderWithBanner extends Component{
    isRussian;
    constructor(props){
        super(props);
        this.state={
            openPopUp : false,
            showNav:false
        }
        this.isRussian = JSON.parse(localStorage.getItem('russianuser'));
    }
    handleOnHover = () =>{
        this.setState({
            openPopUp : true
        })
    }
    handleOnHoverLeave =()=>{
        this.setState({
            openPopUp : false
        })
    }
    handleNav =()=>{
        this.setState({
            showNav:!this.state.showNav
        })
    }
    handleClose=()=>{
        this.setState({
            showNav:false
        })
    }
    render(){
        return(
            <div className="headerWithBannerWrapper">
                <div className="bannerImage">
                <div className="headerTitle">
                    <Link to="/">
                        <img src={JJ_IMedical_icon} alt="iMedical Search" style={{width:"30%",paddingTop:"2%"}}/>
                    </Link>
                </div>
                </div>
            </div>
        )
    }
}
export default HeaderWithBanner;